import { render, staticRenderFns } from "./ClientBankAccount.vue?vue&type=template&id=521c72cf&"
import script from "./ClientBankAccount.vue?vue&type=script&lang=js&"
export * from "./ClientBankAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports